import React from 'react';
import './LegalPages.css';

const Disclaimer = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <div className="legal-content">
          <h1>Disclaimer</h1>
          <p className="last-updated">Last updated: January 2025</p>
          
          <section>
            <h2>1. General Disclaimer</h2>
            <p>
              The information provided on the Vishwa Deva Homestay website is for general informational 
              purposes only. While we strive to keep the information up to date and correct, we make no 
              representations or warranties of any kind, express or implied, about the completeness, 
              accuracy, reliability, suitability, or availability of the information, products, services, 
              or related graphics contained on the website for any purpose.
            </p>
          </section>

          <section>
            <h2>2. No Warranty</h2>
            <p>
              Any reliance you place on such information is therefore strictly at your own risk. 
              In no event will we be liable for any loss or damage including without limitation, 
              indirect or consequential loss or damage, arising from loss of data or profits 
              arising out of, or in connection with, the use of this website.
            </p>
          </section>

          <section>
            <h2>3. Booking and Reservation Disclaimer</h2>
            <p>
              All bookings and reservations are subject to availability and confirmation. 
              We reserve the right to refuse service, cancel bookings, or modify terms and 
              conditions at our discretion. Rates and availability are subject to change 
              without prior notice.
            </p>
            <ul>
              <li>Check-in time: 12:00 PM onwards</li>
              <li>Check-out time: 11:00 AM</li>
              <li>Early check-in and late check-out are subject to availability</li>
              <li>Cancellation policies apply as per our terms and conditions</li>
            </ul>
          </section>

          <section>
            <h2>4. Service Disclaimer</h2>
            <p>
              While we strive to provide the best possible service, we cannot guarantee:
            </p>
            <ul>
              <li>Uninterrupted or error-free service</li>
              <li>Specific room assignments or views</li>
              <li>Availability of all amenities at all times</li>
              <li>Exact pricing due to seasonal variations</li>
              <li>Transportation services during peak seasons</li>
            </ul>
          </section>

          <section>
            <h2>5. Third-Party Services</h2>
            <p>
              Our website may contain links to third-party websites and services. We are not 
              responsible for the content, privacy policies, or practices of any third-party 
              websites or services. Your use of such third-party services is at your own risk.
            </p>
          </section>

          <section>
            <h2>6. External Links Disclaimer</h2>
            <p>
              Through this website, you are able to link to other websites which are not under 
              the control of Vishwa Deva Homestay. We have no control over the nature, content, 
              and availability of those sites. The inclusion of any links does not necessarily 
              imply a recommendation or endorse the views expressed within them.
            </p>
          </section>

          <section>
            <h2>7. Health and Safety Disclaimer</h2>
            <p>
              While we maintain high standards of cleanliness and safety, guests are responsible 
              for their own health and safety during their stay. We are not liable for any 
              accidents, injuries, or health issues that may occur during your stay.
            </p>
          </section>

          <section>
            <h2>8. Force Majeure</h2>
            <p>
              We shall not be liable for any failure to perform our obligations where such 
              failure is a result of Acts of Nature (including fire, flood, earthquake, storm, 
              hurricane, or other natural disaster), war, invasion, act of foreign enemies, 
              hostilities (whether war is declared or not), civil war, rebellion, revolution, 
              insurrection, military or usurped power or confiscation, terrorist activities, 
              government sanctions, blockages, embargoes, labor disputes, or other events 
              beyond our reasonable control.
            </p>
          </section>

          <section>
            <h2>9. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by applicable law, Vishwa Deva Homestay shall not 
              be liable for any indirect, incidental, special, consequential, or punitive damages, 
              or any loss of profits or revenues, whether incurred directly or indirectly, or any 
              loss of data, use, goodwill, or other intangible losses.
            </p>
          </section>

          <section>
            <h2>10. Jurisdiction</h2>
            <p>
              This disclaimer is governed by and construed in accordance with the laws of India. 
              Any disputes arising from the use of this website shall be subject to the exclusive 
              jurisdiction of the courts in Varanasi, Uttar Pradesh, India.
            </p>
          </section>

          <section>
            <h2>11. Changes to Disclaimer</h2>
            <p>
              We reserve the right to modify this disclaimer at any time. Changes will be 
              effective immediately upon posting on the website. Your continued use of the 
              website constitutes acceptance of any changes.
            </p>
          </section>

          <section>
            <h2>12. Contact Information</h2>
            <p>
              If you have any questions about this disclaimer, please contact us:
            </p>
            <div className="contact-info">
              <p><strong>Vishwa Deva Homestay</strong></p>
              <p>Phone: +919415600200</p>
              <p>Email: info@vishwadeva.com</p>
              <p>Address: D53/106 CHHOTI GAIBI, Rathyatra - Mahmoorganj Rd, opposite BCG SCHOOL FOR DEAF AND DUMB, Varanasi, Uttar Pradesh 221010</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer; 